import { http } from "../../lib/http";

/* ------------------------------- ÓRDENES ------------------------------ */
export const orders = {
  list: (params) => http.get("/admin/orders", { params }).then((r) => r.data),
  show: (id) => http.get(`/admin/orders/${id}`).then((r) => r.data),
  /** Cambia el estado (1..4) reusando la validación ya existente del backend. */
  /**
   * Cambia el estado del pedido reusando la validación que ya existe.
   *
   * El endpoint valida `order_id` (no `orderSales_id`: mandarlo con el otro
   * nombre devolvía 422 en cada intento) y, para la transición 2→3, exige el
   * `user_id` del domiciliario al que se le despacha.
   */
  updateState: (order_id, state, user_id = null) =>
    http
      .put("/orders/update", {
        order_id,
        state,
        ...(user_id ? { user_id } : {}),
      })
      .then((r) => r.data),
};


/* ----------------------------- DOMICILIARIOS -------------------------- */
export const domiciliaries = {
  list: (params) =>
    http.get("/admin/domiciliaries", { params }).then((r) => r.data),
  create: (body) => http.post("/admin/domiciliaries", body).then((r) => r.data),
  show: (id) => http.get(`/admin/domiciliaries/${id}`).then((r) => r.data),
  update: (id, body) =>
    http.put(`/admin/domiciliaries/${id}`, body).then((r) => r.data),
  /** Turno: si acepta pedidos hoy. No afecta su acceso a la app. */
  setAvailable: (id, available) =>
    http.put(`/admin/domiciliaries/${id}`, { available }).then((r) => r.data),
  /**
   * Acceso: bloquea la cuenta para que no pueda entrar a la app. Revoca sus
   * sesiones abiertas y lo saca de la rueda de asignación.
   */
  setBlocked: (id, blocked) =>
    http.put(`/admin/domiciliaries/${id}`, { blocked }).then((r) => r.data),
  /**
   * Firma el acuerdo de vinculación: el servidor arma el PDF con los datos ya
   * registrados y la firma trazada, y lo archiva entre los documentos de la
   * persona. `signature` es un PNG en data URL.
   */
  signContract: (id, body) =>
    http
      .post(`/admin/domiciliaries/${id}/contrato`, body, { timeout: 60000 })
      .then((r) => r.data),
};


/* -------------------------------- CHATS ------------------------------- */
export const chats = {
  list: (params) => http.get("/admin/chats", { params }).then((r) => r.data),
  messages: (chatId) =>
    http.get(`/admin/chats/${chatId}/messages`).then((r) => r.data),
};


/*
 * Solicitudes de la web pública. Sin `create`: nacen en el formulario de la
 * landing, y una fila escrita a mano desde el panel no tendría detrás la
 * autorización de tratamiento de datos que la ley exige.
 */
export const solicitudes = {
  list: (params) =>
    http.get("/admin/solicitudes", { params }).then((r) => r.data),
  show: (id) => http.get(`/admin/solicitudes/${id}`).then((r) => r.data),
  update: (id, body) =>
    http.put(`/admin/solicitudes/${id}`, body).then((r) => r.data),
  /* La foto o el comprobante de una PQRS. Vive en el disco privado del
     servidor y la ruta pide el token en la cabecera: se baja con axios. */
  adjunto: (id) =>
    http
      .get(`/admin/solicitudes/${id}/adjunto`, { responseType: "blob" })
      .then((r) => r.data),
};


/* ------------------------------- PANEL -------------------------------- */
export const overview = {
  /**
   * KPIs globales y series temporales. `range` en días.
   * Devuelve { totals, series, breakdown, recent }.
   */
  get: (range = 30) =>
    http.get("/admin/overview", { params: { range } }).then((r) => r.data),
};
